<template>
  <div class="request-status">
    <transition name="banner">
      <div v-if="errorVisible" class="error-banner" role="alert">
        <div class="error-copy">
          <strong>Something needs attention.</strong>
          <span>{{ errorMessage }}</span>
        </div>
        <md-button class="md-icon-button md-dense" @click="dismiss">
          <md-icon>close</md-icon>
        </md-button>
      </div>
    </transition>

    <transition name="fade">
      <div v-if="isLoading" class="loading-overlay" aria-live="polite" aria-busy="true">
        <div class="loading-pill">
          <md-progress-spinner :md-diameter="26" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
          <span>Loading...</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { dismissRequestError, requestStatus } from "@/shared/request-status";

export default {
  name: "GlobalRequestStatus",
  computed: {
    errorMessage() {
      return requestStatus.errorMessage;
    },
    errorVisible() {
      return requestStatus.errorVisible;
    },
    isLoading() {
      return requestStatus.pendingCount > 0;
    },
  },
  methods: {
    dismiss() {
      dismissRequestError();
    },
  },
};
</script>

<style lang="scss" scoped>
.request-status {
  pointer-events: none;
}

.error-banner {
  position: fixed;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1200;
  width: min(680px, calc(100vw - 32px));
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #fff7ed;
  border: 1px solid #fdba74;
  box-shadow: 0 12px 30px rgba(120, 53, 15, 0.18);
  color: #9a3412;
  pointer-events: auto;
}

.error-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.55);
}

.loading-pill {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 16px 32px rgba(15, 23, 42, 0.14);
  color: #334155;
  font-weight: 600;
}

.fade-enter-active,
.fade-leave-active,
.banner-enter-active,
.banner-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.fade-enter,
.fade-leave-to,
.banner-enter,
.banner-leave-to {
  opacity: 0;
}

.banner-enter,
.banner-leave-to {
  transform: translate(-50%, -8px);
}
</style>
